import { InputLabel } from '@mui/material';
import { BrandKey } from '@prismamedia/one-brandkey';
import {
  CategoryFormat,
  CategoryStatus,
  GetBrandCategoriesQuery_query_categories_Category,
} from '__generated__/queries-web';
import { Suggest } from 'components/Suggest';
import { SuggestItemType } from 'components/Suggest/types';
import { flatten } from 'components/Suggest/utils';
import { useGetBrandCategories } from 'pages/CampaignPage/CampaignEditPage/ContentPage/ResourceList/AdvancedSearch/CategorySelect/getCategories.web.graphql';
import { AutomationConfigType } from 'pages/NewsletterPage/NewsletterEditPage/Generalities/AutomationFields';
import { FC, useEffect, useRef, useState } from 'react';
import { getFilteredBrandKey } from 'utils/queries/variables';

interface CategoriesSelectProps {
  automationConfig?: AutomationConfigType;
  brandKey: BrandKey;
  onChange: (selectedCategoriesId: string[]) => void;
  disabled?: boolean;
}

export const CategoriesSelect: FC<CategoriesSelectProps> = (props) => {
  const { brandKey, automationConfig, onChange, disabled = false } = props;

  const [categories, setCategories] = useState<
    GetBrandCategoriesQuery_query_categories_Category[]
  >([]);
  const [selectedCategories, setSelectedCategories] = useState<
    SuggestItemType[]
  >([]);

  const flatCategories = useRef<SuggestItemType[]>([]);

  const getCategories = useGetBrandCategories();

  const fetchCategories = async () => {
    const { categories: data } = await getCategories({
      where: {
        status: CategoryStatus.Published,
        format: CategoryFormat.Category,
        level: 2,
        ...getFilteredBrandKey(brandKey),
      },
    });
    // eslint-disable-next-line immutable/no-mutation
    flatCategories.current = flatten(data);
    setCategories(data);
    setSelectedCategories(
      findSelectedCategories(automationConfig?.categoryIds || []),
    );
  };

  const findSelectedCategories = (categoryIds: string[]) => {
    if (categoryIds.length === 0 || flatCategories.current.length === 0) {
      return [];
    }

    return flatCategories.current.filter(
      (flatCategorie) => categoryIds.indexOf(flatCategorie.id) !== -1,
    );
  };

  useEffect(() => {
    setSelectedCategories(
      findSelectedCategories(automationConfig?.categoryIds || []),
    );
  }, [automationConfig]);

  useEffect(() => {
    fetchCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <InputLabel shrink>Catégories :</InputLabel>
      <Suggest
        selectedItems={selectedCategories}
        placeholder="Rechercher une catégorie"
        suggestions={categories.length > 0 ? categories[0].children : []}
        multiple={true}
        isPrefetched
        disabled={disabled}
        onChange={(items) => onChange(items.map((i) => i.id))}
      />
    </>
  );
};
